import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Newnavigation from '../../../components/new-navigation/new_navigation';
import AboutusBanner from '../../../components/Aboutus-banner/AboutusBanner';
import ContactNew from '../../../components/contact-form/ContactNew';
import Footer from '../../../components/footer/Footer';
import { INFO_TECH_BG, RETAIL_ECOMMERCE} from '../../../assets/images';
import { ITO_heading, ITOAccord, CoreServices,WhyTechno,TestimonialData } from '../../../utils/ito';
import {  InformationTechnologySeo, Retail_Ecommerce} from '../../../utils/Seo';
import HeaderSeo from '../../../components/HeaderSeo/Headerseo';
import ComAccord from '../../../components/Accordian/ComAccord';
import RetailProgress from '../../../components/RetailProgress/RetailProgress';
import CoreServicesList from '../../../components/core-serices/core-services';
import Testimonials from '../../../components/Testimonials/Testimonials';

const ITO = () => {
  const sectionRef = useRef()
  const refcustom = sectionRef.current
    useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }, []);
    return (
        <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
        <div className='service-page' ref={sectionRef}>
            <Newnavigation routeName="services"/>
            <HeaderSeo data={InformationTechnologySeo}/>
            <AboutusBanner bg={INFO_TECH_BG} data={ITO_heading}/>
            <CoreServicesList title="Our Information Technology Outsourcing Services" data={CoreServices} />
            <RetailProgress steps={WhyTechno} heading={"Why Choose Techno Genesis for Information Technology Outsourcing?"}/>
            <Testimonials data={TestimonialData} />
            <div className="mb-50">
              <ComAccord data={ITOAccord} />
            </div>
            <ContactNew />
            <Footer />
        </div>
        </motion.div>
    )
}

export default ITO